// Albanian-first UI (Phase 1, V1 — no language switch yet): every date
// shown to the journalist renders in Albanian, via the "sq-AL" locale.
const DATE_FORMATTER = new Intl.DateTimeFormat("sq-AL", { day: "numeric", month: "short", year: "numeric" });
const DATETIME_FORMATTER = new Intl.DateTimeFormat("sq-AL", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatDate(value: string | null | undefined): string {
  if (!value) return "—";
  const parsed = new Date(value.length === 10 ? `${value}T00:00:00Z` : value);
  if (Number.isNaN(parsed.getTime())) return "—";
  return DATE_FORMATTER.format(parsed);
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "—";
  return DATETIME_FORMATTER.format(parsed);
}

/**
 * Plain calendar-date ISO (YYYY-MM-DD) built from a Date's LOCAL
 * year/month/day — i.e. the calendar day as the viewer's own browser
 * displays it. Deliberately NOT `.toISOString()` (which reads UTC
 * components): converting a browser-local midnight Date through UTC can
 * roll it onto the adjacent calendar day depending on the viewer's
 * timezone offset. EditorialCalendarEvent's `start_date` (and the rest
 * of this app's calendar-day fields) are plain dates with no time/zone
 * component, so every Date <-> ISO-date conversion for the Calendar
 * screen must stay in this same local-only representation end to end —
 * see CalendarScreen.tsx.
 */
export function toLocalIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Inverse of toLocalIsoDate — a local-midnight Date for a "YYYY-MM-DD" string, matching how react-day-picker represents calendar days internally. */
export function parseLocalIsoDate(iso: string): Date {
  const [year, month, day] = iso.split("-").map(Number);
  return new Date(year ?? 1970, (month ?? 1) - 1, day ?? 1);
}
